import {Injectable} from '@angular/core';
import {AlertController, LoadingController, ToastController} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class UiUtils {

  loading: any;
  alert: any;
  isLoading = false;

  constructor(private toastController: ToastController,
              private alertController: AlertController,
              private loadingController: LoadingController) {
  }

  async presentToastWithOptions() {
    const toast = await this.toastController.create({
      header: 'Toast header',
      message: 'Click to Close',
      position: 'top',
      buttons: [
        {
          side: 'start',
          icon: 'star',
          text: 'Favorite',
          handler: () => {
            console.log('Favorite clicked');
          }
        }, {
          text: 'Done',
          role: 'cancel',
          handler: () => {
            console.log('Cancel clicked');
          }
        }
      ]
    });
    await toast.present();
  }

  async showToast(message: string, duration: number = 2000, position: 'bottom' | 'middle' | 'top' = 'bottom', showCloseButton = true ) {
    const toast = await this.toastController.create({
      message,
      duration,
      position,
      showCloseButton
    });
    await toast.present();
  }

  async showAlert(message: string, header?: string, subHeader?: string, buttons?: any, inputs?: any) {
    this.alert = await this.alertController.create({
          header,
          subHeader,
          message,
          buttons: buttons || []
    });
    await this.alert.present();
  }

  hideAlert() {
    if (this.alert) {
      this.alert.dismiss();
    }
  }

  async showLoading(message?: string) {
    this.isLoading = true;
    this.loading = await this.loadingController.create({
      message,
    });
    this.loading.present();

    return this.loading;
  }

  async hideLoading() {
    if (this.loading) {
      await this.loading.dismiss();
    }
  }

  confirm(onOk: any, onCancel: any, message: string = 'Tem a certeza?', title: string = 'Confirmar', okText: string = 'Sim', cancelText: string = 'Não') {
    this.alertController.create({
      header: title,
      message: message,
      buttons: [
        {
          text: cancelText,
          role: 'cancel',
          handler: onCancel
        },
        {
          text: okText,
          handler: onOk
        }
      ]
    }).then(a => a.present());
  }
  
  showConfirmAlert(maintext: string, subtext: string, acceptText: string , onAccept?: Function, cancelText?: string, onCancel?: Function) {
    const btnAccept = { text: acceptText, handler: onAccept };
    const btnCancel = { text: cancelText, handler: onCancel };
    
    const buttons = [btnAccept];
    if(cancelText) buttons.push(btnCancel);
    
    this.showAlert(subtext , maintext, '', buttons);
  }
}
